<template>
      <article class="tile is-child box">
        <div class="field has-addons">
          <div class="control">
            <input class="input" type="text" placeholder="Your Token" v-model="bindToken">
          </div>
          <div class="control">
            <a class="button is-primary" @click="setToken()">
              Login
            </a>
          </div>
        </div>
      </article>
</template>

<script>
export default {
  name: 'TileToken',
  data: function() {
    return {
      bindToken: "",
    }
  },
  methods: {
    setToken: function() {
      
      this.$store.commit('setToken', this.bindToken)
      this.$emit('loggedin')
    }
  }
}
</script>

<style>
@import "~bulma/css/bulma.css";
</style>